import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DatePickerModule } from 'primeng/datepicker';
import { DialogModule } from 'primeng/dialog';
import { EditorModule } from 'primeng/editor';
import { FieldsetModule } from 'primeng/fieldset';
import { FloatLabelModule } from 'primeng/floatlabel';
import { IconFieldModule } from 'primeng/iconfield';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputIconModule } from 'primeng/inputicon';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { PopoverModule } from 'primeng/popover';
import { SelectModule } from 'primeng/select';
import { TableModule } from 'primeng/table';
import { TabsModule } from 'primeng/tabs';
import { TextareaModule } from 'primeng/textarea';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { TreeSelectModule } from 'primeng/treeselect';
import { TreeTableModule } from 'primeng/treetable';

import { firstValueFrom } from 'rxjs';

import { isStringEqual } from '../../common/functions';
import { AppUserService, IAppUser } from '../../services/insecta';
import { MSGraphService } from '../../services/msgraph.service';
import { UserDisplayNamePipe } from './user-display-name.pipe';
import { UserImagePipe } from './user-photo.pipe';

@Component({
  selector: `app-address-book`,
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    BreadcrumbModule,
    ButtonModule,
    CardModule,
    CheckboxModule,
    ChipModule,
    ContextMenuModule,
    CommonModule,
    DatePickerModule,
    DialogModule,
    EditorModule,
    FloatLabelModule,
    FieldsetModule,
    FormsModule,
    IconFieldModule,
    InputGroupModule,
    InputGroupAddonModule,
    InputIconModule,
    InputNumberModule,
    InputTextModule,
    PopoverModule,
    RouterModule,
    SelectModule,
    TableModule,
    TabsModule,
    TextareaModule,
    ToggleSwitchModule,
    TreeSelectModule,
    TreeTableModule,
    UserDisplayNamePipe,
    UserImagePipe
  ],
  templateUrl: `address-book.component.html`
})
export class AddressBookComponent implements OnDestroy, OnInit {
  @Input() labelText: string = ``;
  @Input() addressList: string[] = [];
  @Input() disable: boolean = false;
  @Input() excludeEmails: string[] = [];
  @Output() addressListChange = new EventEmitter<string[]>();

  pageVars: any = {
    currentUser: ``,
    isDirty: false,
    isReady: false
  };

  dlgVars: any = {
    visible: false
  };

  infoVars: any = {
    user: undefined,
    info: undefined,
    visible: false
  };

  selectedAddresses: string[] = [];
  selectedUsers: IAppUser[] = [];
  addressBook: IAppUser[] = [];

  // Filtered address book that excludes specified emails
  get filteredAddressBook(): IAppUser[] {
    if (!this.excludeEmails || this.excludeEmails.length === 0) {
      return this.addressBook;
    }
    return this.addressBook.filter(
      (user) => !this.excludeEmails.some((excludeEmail) => isStringEqual(user.email, excludeEmail))
    );
  }

  constructor(
    private appUserService: AppUserService,
    private graphService: MSGraphService
  ) {}

  ngOnDestroy() {}

  async ngOnInit() {
    this.addressBook = await firstValueFrom(this.appUserService.getAppUsers());
  }

  chipRemove(userEmail: string) {
    const userIdx = this.addressList.findIndex((email) => isStringEqual(email, userEmail));
    if (userIdx >= 0) {
      this.addressList.splice(userIdx, 1);
      this.addressListChange.emit(this.addressList);
    }
  }

  dlgCancel() {
    this.dlgVars.visible = false;
  }

  dlgSelect() {
    this.selectedAddresses = this.selectedUsers.length === 0 ? [] : this.selectedUsers.map((x) => x.email);
    this.addressList = this.selectedUsers.map((x) => x.email);
    this.addressListChange.emit(this.addressList);
    this.dlgVars.visible = false;
  }

  dlgShow() {
    this.selectedAddresses = (this.addressList?.length ?? 0) === 0 ? [] : this.addressList.map((x) => x);
    this.selectedUsers = this.selectedAddresses.map((addy) => <IAppUser>this.addressBook.find((user) => isStringEqual(user.email, addy)));
    this.dlgVars.visible = true;
  }

  async infoShow(user: IAppUser) {
    this.infoVars.user = user;
    this.infoVars.info = await firstValueFrom(this.graphService.getUserProfile$(this.infoVars.user.email));
    this.infoVars.visible = true;
  }

  infoHide() {
    this.infoVars.visible = false;
    this.infoVars.user = undefined;
  }
}
